import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";
import { JobBlockContent, UpdateJobBlockPayload } from "./LandingPageJobBlocks.d";

export const fetchJobBlocks = (setJobBlocks: Function, language: string, setLoading?: Function) => {
  setLoading?.(true);

  ApiService.get("landing-page/job-blocks")
    .then((response) => setJobBlocks(response.data.job_blocks))
    .catch((error) => {
      console.error("Error fetching job blocks:", error);
      alert(translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ERROR.FETCH"));
    })
    .finally(() => setLoading?.(false));
};

export const createJobBlock = (payload: JobBlockContent, language: string, onSuccess?: Function) => {
  ApiService.post("landing-page/job-blocks", payload)
    .then(() => onSuccess?.())
    .catch((error) => {
      console.error("Error creating job block:", error);
      alert(translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ERROR.CREATE"));
    });
};

export const updateJobBlock = (
  jobBlockId: string,
  payload: UpdateJobBlockPayload,
  language: string,
  onSuccess?: Function
) => {
  ApiService.put(`landing-page/job-blocks/${jobBlockId}`, payload)
    .then(() => onSuccess?.())
    .catch((error) => {
      console.error("Error updating job block:", error);
      alert(translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ERROR.UPDATE"));
    });
};

export const deleteJobBlock = (jobBlockId: string, language: string, onSuccess?: Function) => {
  ApiService.delete(`landing-page/job-blocks/${jobBlockId}`)
    .then(() => onSuccess?.())
    .catch((error) => {
      console.error("Error deleting job block:", error);
      alert(translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ERROR.DELETE"));
    });
};

export const reorderJobBlocks = (orderedJobBlockIds: string[], language: string, onSuccess?: Function) => {
  ApiService.put("landing-page/job-blocks/order", {
    order: orderedJobBlockIds,
  })
    .then(() => onSuccess?.())
    .catch((error) => {
      console.error("Error reordering job blocks:", error);
      alert(translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ERROR.REORDER"));
    });
};

export const intToHex = (color?: number) =>
  color !== undefined ? `#${color.toString(16).padStart(6, "0")}` : "var(--color-smoke-gray)";

export const CATEGORIES = ["Dev", "Data", "Cyber", "Digital", "Autre"];

export const SUBCATEGORIES = ["Quiz métier", "Quiz technologique"];
